// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://localhost:44384',
  apiUrl: 'https://pruebaescuelasecretarias.ivolucion.com',
  //apiUrl: 'https://escuelassecretariaspre.ivolucion.com/backend', /*pre-Production*/
  //apiUrl: 'https://escuelasecretarias.mineducacion.gov.co/backend', /*Production*/
  tempEscuela: 311
  //tempEscuela: 49 /*pre-Production*/
  //tempEscuela:41
  , path_micrositios: 'C:/inetpub/wwwescuelasecretariasfront/'
  //,path_micrositios: 'C:/inetpub/wwwescuelasfrontend' /*pre-Production*/
  //,path_micrositios: 'C:/inetpub/wwwescuelasecretarias' /*Production*/
  , timeout: 15
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
